<div class="banner d-none d-lg-flex" role="banner">
  <div class="container">
    <div class="title-wrapper">
      <img src="assets/images/games/Games_Title.png" alt="" />
    </div>
  </div>
</div>
<fgb-mobile-header-bar [title]="'games.play.title' | translate" [showPoints]="false"></fgb-mobile-header-bar>
<div class="mobile-content-wrapper">
  <div class="container">
    <div class="card border">
      <div class="card-header">
        <img [alt]="'games.page.trivia.title' | translate" src="assets/images/games/trivia.png" />
      </div>
      <div class="card-body">
        <h3>{{ 'games.page.trivia.title' | translate }}</h3>
        <p>{{ 'games.page.trivia.description' | translate }}</p>
        <a class="btn btn-primary" [routerLink]="['/games/trivia']">{{ 'games.page.trivia.button' | translate }}</a>
      </div>
    </div>
    <div class="card border">
      <div class="card-header">
        <img [alt]="'games.page.polls.title' | translate" src="assets/images/games/polls.png" />
      </div>
      <div class="card-body">
        <h3>{{ 'games.page.polls.title' | translate }}</h3>
        <p>{{ 'games.page.polls.description' | translate }}</p>
        <a class="btn btn-primary" [routerLink]="['/games/polls']">{{ 'games.page.polls.button' | translate }}</a>
      </div>
    </div>

    <div class="card border">
      <div class="card-header">
        <img [alt]="'games.page.jump.to.survive.title' | translate" src="assets/images/games/jumptosurvive.png" />
      </div>
      <div class="card-body">
        <h3>{{ 'games.page.jump.to.survive.title' | translate }}</h3>
        <p>{{ 'games.page.jump.to.survive.description' | translate }}</p>
        <a class="btn btn-primary" [routerLink]="['/games/acejump']">{{ 'games.page.jump.to.survive.button' | translate }}</a>
      </div>
    </div>
    <div class="card border">
      <div class="card-header">
        <img [alt]="'games.page.predictor.title' | translate" src="assets/images/games/photo_scramble.png" />
      </div>
      <div class="card-body">
        <h3>{{ 'games.page.photo.scramble.title' | translate }}</h3>
        <p>{{ 'games.page.photo.scramble.description' | translate }}</p>
        <a class="btn btn-primary" [routerLink]="['/games/photoscramble']">{{
          'games.page.photo.scramble.button' | translate
        }}</a>
      </div>
    </div>

    <!-- <div class="card border">
      <div class="card-header">
        <img [alt]="'games.page.player.reveal.title' | translate" src="assets/images/games/player_reveal.png" />
      </div>
      <div class="card-body">
        <h3>{{ 'games.page.player.reveal.title' | translate }}</h3>
        <p>{{ 'games.page.player.reveal.description' | translate }}</p>
        <a class="btn btn-primary" [routerLink]="['/games/playerreveal']">{{ 'games.page.player.reveal.button' | translate }}</a>
      </div>
    </div> -->
  </div>
</div>
